<div class="flex justify-content-center">
<div class="align-self-center mt-8 w-">
    <div class="text-center z-4 border-round-lg border-1 surface-border bg-white p-3 shadow-3 flex flex-column">
        <div class="border-round-md mx-auto border-1 surface-border bg-bluegray-700 px-3 py-1">
            <h2 class="m-0 text-white">Session Expired</h2>
        </div>
        <div class="surface-200 p-3 mb-5 shadow-2 border-round-md mt-3 px-6"><img
                src="./assets/session-timeout-img.png"
                alt="" class="w-5"></div>
                <p-button label="Log In" [raised]="true" routerLink="/" severity="info" size="small" />
    </div>
</div>
</div>
